import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralCatalogSelectService } from '../general-catalog-select.service';

export interface TypeBlockSelectOption {
  value: string;
  label: string;
  code?: string;
}

/** Catálogo `block_types` vía select unificado. */
@Injectable({ providedIn: 'root' })
export class TypeBlockSelectService {
  private readonly generalCatalogSelect = inject(GeneralCatalogSelectService);

  getOptions(): Observable<TypeBlockSelectOption[]> {
    return this.generalCatalogSelect.getListOptionsByPrefix('block_types').pipe(
      map((options) =>
        options.map((o) => ({
          value: o.value,
          label: o.label,
          code: o.code || '',
        })),
      ),
    );
  }
}
